import React from "react"
import ReactDOM from "react-dom"
import App from "./App"

if (process.env.NODE_ENV == "production") console.log = (...data) => {}

ReactDOM.render(<App />, document.getElementById("root"))
